import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type GetDictionariesResponse } from '@shared/api';

interface UseDictionariesStore {
  loading: boolean;
  data?: GetDictionariesResponse | null;
  error: string | null;
  getDictionaries: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDictionariesStore = create<UseDictionariesStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  getDictionaries: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getDictionaries(signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
